import { render, staticRenderFns } from "./RepeatFreqSelect.vue?vue&type=template&id=2852e691&"
import script from "./RepeatFreqSelect.vue?vue&type=script&lang=js&"
export * from "./RepeatFreqSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2852e691')) {
      api.createRecord('2852e691', component.options)
    } else {
      api.reload('2852e691', component.options)
    }
    module.hot.accept("./RepeatFreqSelect.vue?vue&type=template&id=2852e691&", function () {
      api.rerender('2852e691', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Repeat/RepeatFreqSelect.vue"
export default component.exports